import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

// 데미지/힐 숫자 표시
export function DamageNumber({ value, type = 'damage', x, y, onComplete }) {
  const [visible, setVisible] = useState(true);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onComplete?.();
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  
  if (!visible) return null;
  
  const prefix = type === 'heal' ? '+' : type === 'buff' ? '↑' : type === 'debuff' ? '↓' : '-';
  
  return createPortal(
    <div 
      className={`damage-number ${type}`}
      style={{
        left: x,
        top: y,
        zIndex: 9999,
      }}
    >
      {prefix}{Math.abs(value)}
    </div>,
    document.body
  );
}

// 데미지 숫자 매니저
let damageNumbers = [];
let setDamageNumbersState = null;

export function DamageNumberContainer() {
  const [numbers, setNumbers] = useState([]);
  
  useEffect(() => {
    setDamageNumbersState = setNumbers;
    return () => { setDamageNumbersState = null; };
  }, []);
  
  return (
    <>
      {numbers.map((n) => (
        <DamageNumber
          key={n.id}
          value={n.value}
          type={n.type}
          x={n.x}
          y={n.y}
          onComplete={() => {
            setNumbers(prev => prev.filter(item => item.id !== n.id));
          }}
        />
      ))}
    </>
  );
}

let damageId = 0;

export function showDamageNumber(value, type, x, y) {
  if (!setDamageNumbersState) return;
  
  const id = ++damageId;
  
  // 랜덤 오프셋 추가 (겹치지 않게)
  const offsetX = (Math.random() - 0.5) * 40;
  const offsetY = (Math.random() - 0.5) * 20;
  
  setDamageNumbersState(prev => [...prev, {
    id,
    value,
    type,
    x: x + offsetX,
    y: y + offsetY,
  }]);
}

// 타겟 요소 기준으로 데미지 표시
export function showDamageOnElement(element, value, type = 'damage') {
  if (!element) return;
  
  const rect = element.getBoundingClientRect();
  const x = rect.left + rect.width / 2;
  const y = rect.top + rect.height / 3;
  
  showDamageNumber(value, type, x, y);
}
